import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanyprofileOnboarddocumentComponent } from './components/companyprofile-onboarddocument/companyprofile-onboarddocument.component';
import { CtoccompanyOnboardingdocumentNcaComponent } from './components/ctoccompany-onboardingdocument-nca/ctoccompany-onboardingdocument-nca.component';

export const routes: Routes = [
  { path: '', component: CompanyprofileOnboarddocumentComponent },
  { path: 'companyprofile-onboarddocument', component: CompanyprofileOnboarddocumentComponent },
  { path: 'ctoccompany-onboardingdocument-nca', component: CtoccompanyOnboardingdocumentNcaComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorOnboardingRoutingModule { }
